enum ClaimJobStatusCode {
  OPEN_ACTIVE_IN_PROGRESS = 'OPEN_ACTIVE_In Progress',
  OPEN_ACTIVE_PENDING = 'OPEN_ACTIVE_Pending',

  OPEN_APPROVED_WAITING_ON_INVOICE = 'OPEN_APPROVED_Waiting On Invoice',
  OPEN_APPROVED_INVOICE_REVIEW_SERVICE = 'OPEN_APPROVED_Invoice Review - Service',
  OPEN_APPROVED_INVOICE_RECEIVED = 'OPEN_APPROVED_Invoice Recieved',
  OPEN_APPROVED_TO_PAY_BY_ACCOUNTING = 'OPEN_APPROVED-TO-PAY - By Accounting',

  OPEN_PAID_PAYMENT_SENT = 'OPEN_PAID_Payment sent',
  PAID_CLOSED_PAID = 'PAID_CLOSED-PAID',

  DENIED_DECLINED = 'DENIED_DECLINED',

  CANCELED_VOID = 'CANCELED_VOID',
}
export default ClaimJobStatusCode;

export type VerifyClaimStatusCode = Utils.VerifyExtends<
  Model.Enum.ClaimJobStatusCode,
  Utils.ValueOf<typeof ClaimJobStatusCode>
>;